import dayjs from "dayjs";

export function secondsToCustomFormat(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  // Format as HH:mm:ss
  const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;

  return dayjs(formattedTime, "HH:mm:ss");
}

//I have "00:00:00" and I want to convert it to day js object
export function convertToDayjsObject(timeString: string) {
  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;
  return secondsToCustomFormat(totalSeconds);
}
